// Statut professionnel (CDI/CDD uniquement).
export const professionalStatus = ['employe', 'agent-de-maitrise', 'cadre'] as const
export type ProfessionalStatus = (typeof professionalStatus)[number]

export const professionalStatusLabel: Record<ProfessionalStatus, string> = {
  employe: 'Employé',
  'agent-de-maitrise': 'Agent de maîtrise',
  cadre: 'Cadre',
}
